import BusinessIcon from "@mui/icons-material/Business"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined"
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined"
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined"
import PortfolioIcon from "@mui/icons-material/BusinessCenterOutlined"
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined"
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined"
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined"

import PATHS, { getFullPath } from "~constants/paths"
import NavLink from "~app/NavLink"
import { RBAC_RULES } from "~rbac/constants/rbac-rules"
import IsAuthorized from "~rbac/isAuthorized"
import { PROOF_OF_OWNERSHIP_STATUS } from "~constants/proofOfOwnership"

const NavBar = () => (
  <ul>
    <IsAuthorized action={RBAC_RULES.VISIT_DASHBOARD_PAGE}>
      <NavLink to={PATHS.basePath} label="Dashboard">
        <SpeedOutlinedIcon />
        <span className="nav-label">Dashboard</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_PERKS_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.perks)} label="Perks">
        <AssessmentOutlinedIcon />
        <span className="nav-label">Perks</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_MESSAGES_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.messages)} label="Communication">
        <QuestionAnswerOutlinedIcon />
        <span className="nav-label">Communication</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_COMPANIES_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.companies)} label="Companies">
        <BusinessIcon />
        <span className="nav-label">Companies</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_USERS_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.users)} label="Users">
        <AccountCircleIcon />
        <span className="nav-label">Users</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_PORTFOLIO_POO_NAV_LINK}>
      <NavLink
        to={`${getFullPath(PATHS.createPortfolio)}?status=${PROOF_OF_OWNERSHIP_STATUS.CREATED}`}
        label="Create portfolios"
      >
        <PortfolioIcon />
        <span className="nav-label">Create portfolios</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_POO_HISTORY_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.pooHistory)} label="Validation history">
        <HistoryOutlinedIcon />
        <span className="nav-label">Validation history</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_UPLOAD_FILE_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.uploadFile)} label="File Uploader">
        <CloudUploadOutlinedIcon />
        <span className="nav-label">File Uploader</span>
      </NavLink>
    </IsAuthorized>

    <IsAuthorized action={RBAC_RULES.SEE_SUPPORT_TICKETS_NAV_LINK}>
      <NavLink to={getFullPath(PATHS.supportTickets)} label="Support Tickets">
        <SupportAgentOutlinedIcon />
        <span className="nav-label">Support Tickets</span>
      </NavLink>
    </IsAuthorized>
  </ul>
)

export default NavBar
